// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2LMzK","insightsList":"newBusinessInsightsMenu_insightsList__10-H6","active":"newBusinessInsightsMenu_active__2By5p"};